export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  GUEST = 'GUEST',
  UNKNOWN = 'UNKNOWN',
}
